import { render, staticRenderFns } from "./ProjectChanges.vue?vue&type=template&id=8a2fe816&scoped=true"
import script from "./ProjectChanges.vue?vue&type=script&lang=js"
export * from "./ProjectChanges.vue?vue&type=script&lang=js"
import style0 from "./ProjectChanges.vue?vue&type=style&index=0&id=8a2fe816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2fe816",
  null
  
)

export default component.exports